<template>
    <div>
        <full-calendar :events="eventos"
            defaultView="month"
            :config="config"
            @event-selected="eventSelected"
            @event-drop="eventDropped"
            @day-click="dayClicked"
        ></full-calendar>

        <!-- ================= Agregar eveneto ==================== -->

        <b-modal v-b-modal.modalPrevent
                v-model="modalNuevo"
                size="lg"
                ref="nuevoModal"
                title="Nuevo evento"
                header-bg-variant="dark"
                header-text-variant="light"
                ok-title="Guardar"
                cancel-title="Cancelar"
                :no-close-on-backdrop="true"
                @ok="guardarNuevo"
                >
            <b-form>
                <b-container fluid>
                    <b-row>
                        <b-col cols="12">
                            <label for="titulo"><b>Título:</b></label>
                            <b-form-input 
                                id="titulo"
                                v-model="nuevoEvento.title"
                                type="text"
                                :state="nuevoEvento.valido"
                                @change="tituloValido"
                                placeholder="Título"
                                value-zone="ISO">
                            </b-form-input>
                            <b-form-invalid-feedback id="inputLiveFeedback">
                                Debe ingresar un título
                            </b-form-invalid-feedback>
                        </b-col>

                        <b-col cols="12"><br>
                            <b-form-checkbox
                                v-model="nuevoEvento.allDay">
                            Todo el día
                            </b-form-checkbox>
                        </b-col>

                        <b-col cols="4"><br>
                            <label for="titulo"><b>Inicio:</b></label>
                            <datetime 
                                v-model="nuevoEvento.start"
                                type="datetime"
                                input-class="inputDate"
                                :minute-step="15"
                                @input="fechaMinimaNuevo()"
                                ></datetime>
                        </b-col>

                        <b-col cols="4"><br>
                            <label for="titulo"><b>Fin:</b></label>
                            <datetime 
                                v-model="nuevoEvento.end"
                                type="datetime"
                                input-class="inputDate"
                                :minute-step="15"
                                :min-datetime="nuevoEvento.start"
                                ></datetime>
                        </b-col>

                        <b-col cols="12">
                            <label for="end"><b>Color:</b></label><br>
                            <b-button-group>
                                <b-button 
                                    v-for="(element,index) in colores" :key="index"
                                    :variant="activeColorNuevo(element.value) ? element.variant : 'outline-'+element.variant"
                                    @click="nuevoEvento.color = element.value"
                                    >
                                {{element.text}}</b-button>
                            </b-button-group>
                        </b-col>

                        <b-col cols="12">
                            <label for="end"><b>Observaciones:</b></label><br>
                            <b-form-textarea id="textarea1"
                                v-model="nuevoEvento.observaciones"
                                :rows="3"
                                :max-rows="6">
                            </b-form-textarea>
                        </b-col>

                    </b-row>

                </b-container>
            </b-form>
            
        </b-modal>

        <!-- ================= Mostrar eveneto ==================== -->

        <b-modal v-b-modal.modalPrevent
                v-model="modalConsulta.mostrar"
                size="lg"
                :title="modalConsulta.evento.title"
                ok-title="Modificar"
                :header-bg-variant="getColor(modalConsulta.evento.color)"
                header-text-variant="light"
                cancel-title="Cancelar"
                @cancel="cancelarNuevo()"
                @ok="modificarModal(modalConsulta.evento)"
                >
            <b-container fluid>
                <b-row>
                    <b-col cols="12">
                        <h5>Inicio: {{getFecha(modalConsulta.evento.start,modalConsulta.evento.allDay)}}</h5>
                        <h5>Fin: {{getFecha(modalConsulta.evento.end,modalConsulta.evento.allDay)}}</h5>
                        <h5 v-if="modalConsulta.evento.allDay">Todo el día</h5>
                        <p>{{modalConsulta.evento.observaciones}}</p>
                    </b-col>
                </b-row>
            </b-container>

            <div slot="modal-footer" class="w-100">
                <b-row>
                    <b-col sm="8">
                        <b-btn v-if="puedeModificar" variant="danger" @click="eliminarEvento()">Eliminar</b-btn>
                    </b-col>
                    <b-col sm="2">
                        <b-btn v-if="puedeModificar" class="float-right" variant="primary" @click="modificarModal(modalConsulta.evento)">Modificar</b-btn>
                    </b-col>
                    <b-col sm="2">
                        <b-btn class="float-right" variant="secondary" @click="modalConsulta.mostrar=false">Cerrar</b-btn>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { FullCalendar } from 'vue-full-calendar'
import 'fullcalendar/dist/fullcalendar.css'

import {Datetime} from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

import axios from 'axios'
import date from 'date-and-time'

import _ from 'underscore'

import moment from 'moment'

export default {
    name: 'AgendaPublica',
    props:["id"],
    components: {
        FullCalendar,
        Datetime
    },
    computed: {
        ...mapGetters([
        "httpURL",
        "sessionToken",
        "permisos",
        "role",
        "userId"
        ]),
        puedeModificar(){
            if(this.role == 'administrador')
                return true;
            else
                return this.usuario ==  this.userId ? true : false;
        }
    },
    watch:{
        id : function(nuevo, anterior) {
            this.$emit('enviandoStart');
            axios.get(this.httpURL+'/comsocial/agenda/'+nuevo,{headers:{token:this.sessionToken}})
              .then(res => {
                  //console.log(res.data);
                  this.eventos = res.data.agenda.evento;
                  this.eventos.forEach(element => {
                      element.start = moment(element.start);
                      element.end = moment(element.end);
                  });
                  //console.log(this.eventos);
                  this.$emit('enviandoStop');
              })
              .catch(error => {
                  if(error.response){
                      swal("Oops!",error.response.data.mensaje , "error")
                  }else if( error.request){
                      swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
                  }
                  this.$emit('enviandoStop');
              });
        }
    },
    data: function () {
        return {
            usuario:null,
            config: {
                editable:false,
                timeZone: 'local',
                locale: 'es',
                buttonText: {
                    today:    'Hoy',
                    month:    'Mes',
                    week:     'Semana',
                    day:      'Día',
                    list:     'Lista'
                }
            },
            nuevoEvento:{
                title: '',
                start: new Date().toISOString(),
                end: new Date().toISOString(),
                allDay:false,
                observaciones:'',
                color: '#20a8d8',
                observaciones: '',
                valido: null
            },
            modalNuevo: false,
            modificar:false,
            modalConsulta: {
                mostrar: false,
                evento: {
                    title: '',
                    start: new Date().toISOString(),
                    end: new Date().toISOString(),
                    allDay:false,
                    observaciones:'',
                    color: '#20a8d8',
                    observaciones: '',
                    valido: null
                }
            },
            eventos: [],
            colores: [
                { text: 'Color 1', value: '#20a8d8', variant: 'primary' },
                { text: 'Color 2', value: '#4dbd74', variant: 'success' },
                { text: 'Color 3', value: '#f86c6b', variant: 'danger' },
                { text: 'Color 4', value: '#ffc107', variant: 'warning'},
                { text: 'Color 5', value: '#63c2de', variant: 'info' },
                { text: 'Color 6', value: '#2f353a', variant: 'dark'}
            ]
        }
    },
    created(){
        this.$emit('enviandoStart');
            axios.get(this.httpURL+'/comsocial/agenda/'+this.id,{headers:{token:this.sessionToken}})
                .then(res => {
                    //console.log(res.data);
                    this.usuario = res.data.agenda.usuario;
                    this.eventos = res.data.agenda.evento;
                    this.eventos.forEach(element => {
                        element.start = moment(element.start);
                        element.end = moment(element.end);
                    });
                    //console.log(this.eventos);
                    this.$emit('enviandoStop');
                })
                .catch(error => {
                    if(error.response){
                        swal("Oops!",error.response.data.mensaje , "error")
                    }else if( error.request){
                        swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
                    }
                    this.$emit('enviandoStop');
                });
    },
    methods: {
        setShowDate(d) {
            this.calendario.showDate = d;
        },
        eventSelected(event, jsEvent, view){
            this.modificar = false;
            let pos = this.eventos.findIndex(x => x._id == event._id);
            this.modalConsulta.evento = this.eventos[pos];
            this.modalConsulta.mostrar = true;
        },
        modificarModal(evento){
            this.nuevoEvento = _.clone(evento);
            this.nuevoEvento.start = this.nuevoEvento.start.toISOString();
            this.nuevoEvento.end = this.nuevoEvento.end.toISOString();
            this.modificar = true;
            this.modalNuevo = true;
        },
        eventDropped(event){
            // console.log('Evento cambiado');
            // console.log(event);
        },
        dayClicked(date, jsEvent, view){
            //console.log(date.toISOString());
            if( this.puedeModificar){
                let fecha = new Date(date);
                fecha.setDate(fecha.getDate()+1);
                fecha.setHours(7);
                fecha.setMinutes(0);
                this.nuevoEvento.start = fecha.toISOString();
                fecha.setMinutes(30);
                this.nuevoEvento.end = fecha.toISOString();
                this.modalNuevo = true;
            }
        },
        cancelarNuevo(){
            this.nuevoEvento = {
                title: '',
                start: '',
                end: '',
                allDay:false,
                observaciones:'',
                color: '#20a8d8',
                valido: null
            };
            this.modalNuevo = false;
            this.modificar = false;
        },
        guardarNuevo(evt){
            evt.preventDefault();
            if( this.nuevoEvento.title.length < 3  )
                this.nuevoEvento.valido = false; 
            else{
                this.nuevoEvento.valido = true;
                this.$emit('enviandoStart');
                
                if( !this.modificar ){
                    axios.post(this.httpURL+'/comsocial/agenda/evento/'+this.id,
                        {
                            title:this.nuevoEvento.title,
                            start:this.nuevoEvento.start,
                            end:this.nuevoEvento.end,
                            allDay:this.nuevoEvento.allDay,
                            observaciones:this.nuevoEvento.observaciones,
                            color:this.nuevoEvento.color
                        },
                        {headers: {token:this.sessionToken}})
                    .then(res => {
                        let evento = res.data.evento;
                        evento.start = moment(evento.start);
                        evento.end = moment(evento.end);
                        this.eventos.push(evento);
                        this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                            text: res.data.mensaje });
                        //this.$refs.nuevoModal.hide();
                        this.cancelarNuevo();
                        this.$emit('enviandoStop');
                    })
                    .catch(error => {
                        if(error.response){
                            this.error = error.response.data.mensaje;
                            //console.log(error.response);
                            this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                text: error.response.data.mensaje });
                        }else if( error.request){
                            this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                text: 'No se pudo establecer una conexión al servidor.' });
                        }
                        this.$emit('enviandoStop');
                    });
                }else{
                    axios.put(this.httpURL+'/comsocial/agenda/evento/'+this.id,
                        {
                            evento: this.nuevoEvento._id,
                            title:this.nuevoEvento.title,
                            start:this.nuevoEvento.start,
                            end:this.nuevoEvento.end,
                            allDay:this.nuevoEvento.allDay,
                            observaciones:this.nuevoEvento.observaciones,
                            color:this.nuevoEvento.color
                        },
                        {headers: {token:this.sessionToken}})
                    .then(res => {
                        let evento = res.data.evento;
                        evento.start = moment(evento.start);
                        evento.end = moment(evento.end);
                        let pos = this.eventos.findIndex(x => x._id == evento._id);
                        this.eventos.splice(pos,1);
                        this.eventos.push(evento);
                        this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                            text: res.data.mensaje });
                        //this.$refs.nuevoModal.hide();
                        this.cancelarNuevo();
                        this.$emit('enviandoStop');
                    })
                    .catch(error => {
                        if(error.response){
                            this.error = error.response.data.mensaje;
                            //console.log(error.response);
                            this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                text: error.response.data.mensaje });
                        }else if( error.request){
                            this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                text: 'No se pudo establecer una conexión al servidor.' });
                        }
                        this.$emit('enviandoStop');
                    });
                }
            }
        },
        eliminarEvento(){
            this.$emit('enviandoStart');
            this.modalConsulta.mostrar = false;
            axios.delete(this.httpURL+'/comsocial/agenda/evento/'+this.id,
                    {data:{evento:this.modalConsulta.evento._id},headers: {token:this.sessionToken}})
                .then(res => {
                    let pos = this.eventos.findIndex(x => x._id == this.modalConsulta.evento._id);
                    this.eventos.splice(pos,1);
                    this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                        text: res.data.mensaje });
                    //this.$refs.nuevoModal.hide();
                    this.$emit('enviandoStop');
                })
                .catch(error => {
                    if(error.response){
                        this.error = error.response.data.mensaje;
                        //console.log(error.response);
                        this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                            text: error.response.data.mensaje });
                    }else if( error.request){
                        this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                            text: 'No se pudo establecer una conexión al servidor.' });
                    }
                    this.modalConsulta.mostrar = true;
                    this.$emit('enviandoStop');
                });
        },
        activeColorNuevo(value){
            return this.nuevoEvento.color === value;
        },
        fechaMinimaNuevo(){
            let inicio = new Date(this.nuevoEvento.start);
            let fin = new Date(this.nuevoEvento.end);
            if( inicio > fin ){
                let date = new Date(this.nuevoEvento.start);
                date.setMinutes(date.getMinutes()+30);
                this.nuevoEvento.end = date.toISOString();
            }
        },
        tituloValido(){
            return this.nuevoEvento.title.length < 3 ? false : null
        },
        getColor(hex){
            let pos = this.colores.findIndex(x => x.value == hex);
            return this.colores[pos].variant;
        },
        getFecha(fecha,allDay){

            return allDay ? moment(fecha).locale('es').format("dddd DD [de] MMMM ") : moment(fecha).locale('es').format("dddd DD [de] MMMM, h:mm")
        }
    }
}
</script>

<style>
.inputDate {
    width: 100%;
}
</style>